import axios from 'axios';
import {
    checkAuthCrmUser,
    createAuthCheckError,
    getAccessToken,
    isLogoutRequest,
    isPublicRequest,
    needsCredentials
} from '@/store/settings';
import store from '@/store/store';

const api = axios.create();

api.defaults.baseURL = '/api/v2/';
api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
api.defaults.withXSRFToken = true;
api.defaults.withCredentials = false;

export const setAuthHeader = (token) => {
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers.common['Authorization'];
    }
};

api.interceptors.request.use(
    async (config) => {
        config.headers = config.headers || {};
        config.withCredentials = needsCredentials(config.url);

        if (isLogoutRequest(config.url)) {
            const token = getAccessToken();

            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        }

        if (isPublicRequest(config.url)) {
            return config;
        }

        const isAuthenticated = await checkAuthCrmUser();

        if (isAuthenticated !== true) {
            return Promise.reject(createAuthCheckError());
        }

        config.headers.token = store.state.token;

        return config;
    },
    (error) => Promise.reject(error)
);

export default api;
